import { render, staticRenderFns } from "./wholeContract.vue?vue&type=template&id=de2e72e0&scoped=true&"
import script from "./wholeContract.vue?vue&type=script&lang=js&"
export * from "./wholeContract.vue?vue&type=script&lang=js&"
import style0 from "./wholeContract.vue?vue&type=style&index=0&id=de2e72e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de2e72e0",
  null
  
)

export default component.exports